(function () {
  /**
   * @ngdoc module
   * @name binky.core.common.list.state.hybrid
   * @description module defining abstract Hybrid List model
   */
  angular.module('binky.core.common.list.state.hybrid', [
    'binky.core.api.jil',
    'binky.core.common.list.state.alpha',
    'binky.core.common.model.cache',
  ]);
})();
